// hooks/useAnzeigeOptik.js — liest, welche Optik ein Bildschirm zeigen soll
// (22.10.2026). Quelle: GET /api/modus-display-config/global (öffentlich, die
// Hallenschirme laufen ohne Anmeldung), Feld global.optik. Eingestellt wird
// in der Modus-Übersicht, Reiter „Anzeige / Display“ (nur Plattform-Admin).
//
// - Zuletzt bekannter Stand liegt im Browser (SPEICHER), damit ein Schirm
//   nach dem Neuladen nicht erst kurz die andere Optik zeigt.
// - Alle 60 Sekunden neu gefragt: ein Hallenschirm läuft den ganzen Tag.
// - Im selben Browser kommt eine Änderung sofort an (storage-Ereignis).
// - ?optik=alt|neu in der Adresse gilt vor der Einstellung.
import { useEffect, useState } from 'react';
import { optikFuer, optikAusAdresse, bereinigeOptik } from '../lib/anzeigeOptik';

export const OPTIK_SPEICHER = 'tda-anzeige-optik';
const ABSTAND_MS = 60000;

function gemerkt() {
  try { return bereinigeOptik(JSON.parse(localStorage.getItem(OPTIK_SPEICHER) || '{}')); } catch { return {}; }
}
function merken(optik) {
  try { localStorage.setItem(OPTIK_SPEICHER, JSON.stringify(optik)); } catch { /* privater Modus */ }
}

/** Nach dem Speichern in der Modus-Übersicht: Schirme in diesem Browser sofort umstellen. */
export function meldeOptik(optik) {
  const sauber = bereinigeOptik(optik);
  const roh = JSON.stringify(sauber);
  merken(sauber);
  try { window.dispatchEvent(new StorageEvent('storage', { key: OPTIK_SPEICHER, newValue: roh })); } catch { /* alte Browser */ }
}

/** Gespeicherte Optik aller Bildschirme, { punktetafel: 'alt', … }. */
export function useOptikEinstellung() {
  const [optik, setOptik] = useState(gemerkt);
  useEffect(() => {
    let aus = false;
    const holen = async () => {
      try {
        const r = await fetch('/api/modus-display-config/global', { cache: 'no-store' });
        if (!r.ok) return;                       // Stand behalten, nicht raten
        const d = await r.json();
        if (aus) return;
        const neu = bereinigeOptik(d?.global?.optik);
        merken(neu);
        setOptik((alt) => (JSON.stringify(alt) === JSON.stringify(neu) ? alt : neu));
      } catch { /* ohne Netz: zuletzt bekannter Stand */ }
    };
    holen();
    const t = setInterval(holen, ABSTAND_MS);
    const beiSpeicher = (e) => {
      if (e.key !== OPTIK_SPEICHER) return;
      try { setOptik(bereinigeOptik(JSON.parse(e.newValue || '{}'))); } catch { /* unbrauchbar */ }
    };
    window.addEventListener('storage', beiSpeicher);
    return () => { aus = true; clearInterval(t); window.removeEventListener('storage', beiSpeicher); };
  }, []);
  return optik;
}

/** 'neu' oder 'alt' für einen Bildschirm (punktetafel, kataTafel, turnierbaum). */
export function useAnzeigeOptik(bildschirm) {
  const optik = useOptikEinstellung();
  return optikAusAdresse(window.location.search) || optikFuer(optik, bildschirm);
}
